import { useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import Table from "../reusable_components/Table";
import AddServiceBundle from "../modals/AddServiceBundle";
import ModifyServiceBundle from "../modals/ModifyServiceBundle";
import Button from "../reusable_components/Button";
import { btnGreen, btnRed, title ,btnOneNoWidth} from "../utils/style";
import edit from '../assets/icons/edit.png'
import deleteIcon from '../assets/icons/delete.png'
import ConfirmationModal from "../reusable_components/ConfirmationModal";
import formatNumberToUs from "../custom_functions/formatNumberToUs";


function ServiceBundle() {
    const [ showAddAndModifyServiceBundle, setShowAddAndModifyServiceBundle ] = useState(false);
    const [ bundleData, setBundleData ] = useState()
    const [ deleteId, setDeteleId ] = useState(null)
    const [ reloadTable, setReloadTable ] = useState(false)

    async function deleteServiceBundle() {
        try {
            const reqUrl = url + '/services/service_bundle/' + deleteId;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.delete(reqUrl, { headers });
            console.log(data);
            setReloadTable(1 + Math.random())
        } catch (error) {
            console.log(error)
        } finally {
            setDeteleId(null)
        }
    }

    function toggleModify(data) {
        setBundleData(data);
        setShowAddAndModifyServiceBundle(true)
    }

    const options = [
        {
            header: 'Bundle Name',
            key: 'name',
        },
        {
            header: 'Cost',
            render: (data) => {
                return(
                    `$${formatNumberToUs(data.cost?.toFixed(2))}`
                )
            },
            filterKey: 'cost'
        },
        {
            header: 'Services',
            render: (data) => {
                return(
                    <>
                        {
                            data.service_lists.map((sl, ind) => <span key={ind}>{`${sl.name}, `}</span>)
                        }
                    </>
                )
            }
        },
        {
            header: 'Action',
            render: (data) => {
                return(
                    <>
                        <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => toggleModify(data)}
                        >
                            <img src={edit} height={15} width={15} />
                        </button>
                        <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => setDeteleId(data.id)}
                        >
                            <img src={deleteIcon} height={15} width={15} />
                        </button>
                    </>
                )
            }
        }
    ]

    const excludeFilter = ['Services', 'Action']

    return(
        <div className="p-4">
            {
                showAddAndModifyServiceBundle && <AddServiceBundle bundleData={bundleData} reload={setReloadTable} setBundleData={setBundleData} setShowModal={setShowAddAndModifyServiceBundle} />
            }
            {
                deleteId && <ConfirmationModal title={'Service Bundle'} setShowForm={setDeteleId} confirm={deleteServiceBundle} />
            }
            {/* {
                showModifyServiceBundle && <ModifyServiceBundle setShowModal={setShowModifyServiceBundle} />
            } */}
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Service Bundle</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Service Bundle`} clickHandler={() => setShowAddAndModifyServiceBundle(!showAddAndModifyServiceBundle)} />
                )}
            </div>
            <Table 
                options={options} 
                url={url + '/services/service_bundle'} 
                pagination 
                clickHandler={() => setShowAddAndModifyServiceBundle(!showAddAndModifyServiceBundle)}
                btnTitle={'Service Bundle'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default ServiceBundle;